import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

@Component({
  selector: 'app-dashboard-qpack',
  templateUrl: './qualification.component.html',
  styleUrls: ['./dashboard.component.css']
})


export class QualificationComponent implements OnInit {

  public alertOption: SweetAlertOptions = {};  
	@ViewChild('qpSelSwal') private qpSelSwal: SwalComponent;
	@ViewChild('createExamSwal') private createExamSwal: SwalComponent;
	@ViewChild('addinBatchSwal') private addinBatchSwal: SwalComponent;
    @ViewChild('msgSwal') private msgSwal: SwalComponent;	
	title = 'Pareekshn';
	selectedValue: any = 'topic';
	userinfo: any;
	studentid: number = 0;
	isErrorUsername: boolean;
	errorMsg: any;
	loading: boolean;
	examdata: any;
	futureexams: any;
	pastexams: any;
	livexam: any;
	isValid = true;
	pg: number = 0;
	usertoken: string;
	todayDate: Date = new Date();
	examicon: string;
	sectorlist = [];
	returnUrl: string;
	sectorid: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) { }

  ngOnInit() {

    //let auth_token = 'MTQ1YjE4ZDI2Mjc1MzQ4MGM2Njc5MTNlNDdmMWY2MGVfUGFyQDIzQE1F';
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    this.usertoken = this.userinfo['usertoken'];
    var step = this.route.snapshot.paramMap.get("step");

    if(step == null || step == undefined)
    {
      this.returnUrl = '/sectors';
    }
    else{
      this.sectorid = parseInt(step);
    }   
    this.chooseqps();
  }

sectorArrLength;
chooseqps()
{ 
  this.loading = true;
  this.spinner.show();
    this.authenticationService.getQPs(this.globals.root_url, this.studentid, this.usertoken, this.sectorid)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          if (data.code == 1000) {
            this.sectorlist = data.qp_list;
            this.sectorArrLength = this.sectorlist.length;
            this.loading = false;
            this.spinner.hide();
          }
          else {
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }
          
        },
        error => {
          this.errorMsg = 'No Result Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }
exam_id: number = 0;
examlist;
examArrLength;
//isAvailableExam: number = 0;	
qpid: number = 0;
loadQPExam(id_qp)
{ 
  this.loading = true;
  this.spinner.show();
  this.loading = true;
  this.spinner.show();
  this.qpid = id_qp;
    this.authenticationService.getEaxmQP(this.globals.root_url, this.studentid, this.usertoken, id_qp)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          if (data.code == 1000) {
            this.examlist = data.exams; 
            //console.log(data.exams.length); return;
            //this.exam_id = this.examlist[0].id_exam
            //this.examArrLength = this.examlist.length; 
            //console.log(this.examArrLength); return;
            if(data.exams.length == 0)
            {
				this.loading = false;
				this.spinner.hide();
				//this.isAvailableExam = 1;
				this.createExamSwal.show(); 
                //this.router.navigateByUrl('/instruction/'+id_qp+'/'+this.sectorid); 
            }
            else
            {
              //this.isAvailableExam = 0;
              this.loading = false;
              this.spinner.hide();
              this.router.navigateByUrl('/dashboard');                                       
            }
          }
          else {
            this.loading = false;
            this.spinner.hide();           
          }
          
        },
        error => {
          //this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );  
 }
 createExam()
 {
  this.msgSwal.show();
  const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
  //const body = { idExam: exam_id, idStudent: this.studentid };
  //this.http.get<any>("https://admintest.pareekshn.in/ams/createmte?idSector="+this.sectorid+"&idQP="+this.qpid, { headers }).subscribe((res: any) => {
  this.http.get<any>("https://mypanel.pareekshn.com/ams/createmte?idSector="+this.sectorid+"&idQP="+this.qpid, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.addinBatchSwal.show();
        this.associateinbatch(res.id_exam);   
        this.loading = false;
        this.spinner.hide();         
        //this.router.navigateByUrl('/dashboard'); 
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
      }
        
  });
 }
 associateinbatch(id_exam)
 {
      const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
      //this.http.get<any>("https://admintest.pareekshn.in/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+id_exam, { headers }).subscribe((res: any) => {
      this.http.get<any>("https://mypanel.pareekshn.com/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+id_exam, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.loading = false;
        this.spinner.hide();         
        this.router.navigateByUrl('/dashboard'); 
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
        this.router.navigateByUrl('/dashboard'); 
      }
        
  });
 }
 goDashboard()
 {
  this.router.navigateByUrl('/dashboard'); 
 }  
}





